export default "__VITE_ASSET__Bfgr7$RI__"